import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { READING_FORMAT_LABELS, READING_FORMAT_ICONS, ReadingFormat } from '@/lib/readingFormatUtils';

interface ReadingFormatSelectorProps {
  value: ReadingFormat;
  onChange: (format: ReadingFormat) => void;
  label?: string;
  className?: string;
}

export function ReadingFormatSelector({ 
  value, 
  onChange, 
  label = "How did you read this book?",
  className 
}: ReadingFormatSelectorProps) {
  const formats: ReadingFormat[] = ['print', 'digital', 'audio'];

  return (
    <div className={className}>
      {label && (
        <Label className="text-sm font-medium mb-3 block">
          {label}
        </Label>
      )}
      <RadioGroup
        value={value || undefined}
        onValueChange={(val) => onChange(val as ReadingFormat)}
        className="grid grid-cols-3 gap-3"
      >
        {formats.map((format) => {
          const Icon = READING_FORMAT_ICONS[format];
          const isSelected = value === format;
          
          return (
            <label
              key={format}
              htmlFor={`format-${format}`}
              className={`
                flex flex-col items-center gap-2 p-4 rounded-lg border-2 cursor-pointer
                transition-all duration-200
                ${isSelected 
                  ? 'border-primary bg-primary/5' 
                  : 'border-border bg-card hover:border-primary/50'
                }
              `}
            >
              <RadioGroupItem
                value={format}
                id={`format-${format}`}
                className="sr-only"
              />
              <Icon className={`w-6 h-6 ${isSelected ? 'text-primary' : 'text-muted-foreground'}`} />
              <span className={`text-sm font-medium ${isSelected ? 'text-primary' : 'text-foreground'}`}>
                {READING_FORMAT_LABELS[format]}
              </span>
            </label>
          );
        })}
      </RadioGroup>
    </div>
  );
}
